
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onas",
      function () {
        return require("private-next-pages/onas/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onas"])
      });
    }
  